import {VehicleTypes} from "@/enums/filters";

const urlConstants = {
    [VehicleTypes.Car]: '/carinsurance/form/',
    [VehicleTypes.Bike]: '/bikeinsurance/form/',
    [VehicleTypes.Truck]: '/truckinsurance/form/',
    [VehicleTypes.Rural]: '/ruralinsurance/form/',
    [VehicleTypes.Taxi]: '/taxiinsurance/form/',
    [VehicleTypes.RentalCar]: '/rentalcarinsurance/form/',
    [VehicleTypes.Trailer]: 'https://www.insurancemarket.gr/asfaleia-rymoulkoumenou-oximatos',
    [VehicleTypes.CrmCar]: '/crmcarinsurance/form/',
    [VehicleTypes.CrmBike]: '/crmbikeinsurance/form/',
    [VehicleTypes.CrmTruck]: '/crmtruckinsurance/form/',
    [VehicleTypes.CrmRural]: '/crmruralinsurance/form/',
    [VehicleTypes.CrmTaxi]: '/crmtaxiinsurance/form/',
    [VehicleTypes.CrmRentalCar]: '/crmrentalcarinsurance/form/'
};

export {urlConstants};
